module.exports = __webpack_public_path__ + "static/media/tools.4b387a0a.svg";